import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { navigateToOrigin } from '../../core/state/mfa/mfa.actions';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/state/shared/root-state.interface';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { SetUpInitialComponent } from './set-up-initial/set-up-initial.component';
import { SetUpAppComponent } from './set-up-app/set-up-app.component';
import { SetUpFinalComponent } from './set-up-final/set-up-final.component';
import { MfaFailComponent } from '../../components/mfa-fail/mfa-fail.component';
import { SetUpChooseMethodComponent } from './set-up-choose-method/set-up-choose-method.component';
import { SetUpEmailComponent } from './set-up-email/set-up-email.component';
import { take } from 'rxjs';
import { selectMfaOriginEmail } from '../../core/state/mfa/mfa.selectors';
import { MfaErrors } from '../../core/state/mfa/mfa.state';

@Component({
  selector: 'app-set-up-two-factor',
  templateUrl: './set-up-two-factor.component.html',
  styleUrls: [
    'set-up-two-factor.component.scss',
    '../login-form/login-form.component.scss',
  ],
  imports: [
    MatCard,
    MatCardContent,
    TranslateModule,
    MatIcon,
    MatIconButton,
    SetUpInitialComponent,
    SetUpAppComponent,
    SetUpFinalComponent,
    SetUpChooseMethodComponent,
    MfaFailComponent,
    SetUpEmailComponent,
  ],
})
export class SetUpTwoFactorComponent implements OnInit, OnDestroy {
  SetUpTwoFactorScreen = SetUpTwoFactorScreen;
  currentScreen: SetUpTwoFactorScreen = SetUpTwoFactorScreen.INITIAL;
  isSetupCompleted = true;
  isTimedOut = false;
  email: string;

  private store = inject(Store<RootState>);
  private cdr = inject(ChangeDetectorRef);
  private timeoutId: ReturnType<typeof setTimeout>;

  ngOnInit() {
    this.store
      .select(selectMfaOriginEmail)
      .pipe(take(1))
      .subscribe((email) => (this.email = email));

    this.setTimeout();
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  onDismiss(): void {
    if (this.currentScreen === SetUpTwoFactorScreen.FINAL) {
      this.close();
    } else {
      this.currentScreen = SetUpTwoFactorScreen.FINAL;
      this.isSetupCompleted = false;
      this.cdr.detectChanges();
    }
  }

  setTimeout(): void {
    this.timeoutId = setTimeout(() => {
      this.isTimedOut = true;
    }, 1800000); // 30 minutes
  }

  onResetTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.isTimedOut = false;
    this.setTimeout();
  }

  changeScreen(screen: SetUpTwoFactorScreen): void {
    this.currentScreen = screen;
  }

  close(): void {
    this.store.dispatch(navigateToOrigin({}));
  }

  protected readonly MfaErrors = MfaErrors;
}

export enum SetUpTwoFactorScreen {
  INITIAL = 'set-up-initial',
  CHOOSE_METHOD = 'set-up-choose-method',
  AUTHENTICATOR_APP = 'set-up-app',
  EMAIL = 'set-up-email',
  FINAL = 'set-up-final',
}
